import React, { useState } from "react";
import "./Auth.css";
import Button from "../components/Button";
import axios from "axios";
import { setToken, setUser } from "../utils/session";

import { API_BASE } from "../utils/apiConfig";

export default function Login({ onAuth, initialEmail = "" }) {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");
    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail || !password) {
      setError("Please enter email and password");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${API_BASE}/auth/login`,
        {
          email: normalizedEmail,
          password,
          rememberMe
        },
        { withCredentials: false }
      );

      setToken(res.data.token, rememberMe);
      if (res.data.user) {
        setUser(res.data.user, rememberMe);
      }
      // Move away from the already-active login state so App re-renders and
      // picks up the newly stored token.
      onAuth("chat");
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Invalid email or password");
      } else if (err.response?.status === 403 && err.response?.data?.code === "EMAIL_NOT_VERIFIED") {
        onAuth("check-email", {
          email: normalizedEmail,
          verificationEmailSent: err.response?.data?.verificationSent !== false,
          notice: err.response?.data?.verificationSent === false
            ? "Your account still needs verification, but the email provider did not accept the message. Please use Resend verification email."
            : ""
        });
      } else if (err.response?.status === 423) {
        setError("Account temporarily locked due to failed attempts");
      } else {
        setError("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card split">

        {/* LEFT PANEL */}
        <div className="auth-left">
          <h1>WELCOME</h1>
          <h3>AI-Powered Document Intelligence</h3>
          <p>
            Securely analyze your documents, chat with AI,
            and manage everything in one place.
          </p>

          <div className="bubble b1" />
          <div className="bubble b2" />
          <div className="bubble b3" />
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-right">
          <h2>Sign in</h2>
          <p className="subtitle">
            Enter your credentials to continue
          </p>

          {error && <div className="auth-error" role="alert">{error}</div>}

          <div className="input-group">
            <input
              placeholder="Email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="input-group">
            <input
              type={show ? "text" : "password"}
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="show-btn" onClick={() => setShow(!show)}>
              {show ? "HIDE" : "SHOW"}
            </span>
          </div>

          <div className="auth-row">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              Remember me
            </label>

            <span
              className="link"
              onClick={() => onAuth("forgot")}
            >
              Forgot Password
            </span>
          </div>

          <Button
            className="primary-btn"
            onClick={handleLogin}
            loading={loading}
          >
            Sign in
          </Button>


          <p className="footer-text">
            Don’t have an account?{" "}
            <span onClick={() => onAuth("signup")}>Sign up</span>
          </p>
        </div>

      </div>
    </div>
  );
}
